// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM8 9.5V8.5H6V9.5C6 10.8807 7.11929 12 8.5 12C9.88071 12 11 10.8807 11 9.5V8.5H9V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5ZM15 9.5V8.5H13V9.5C13 10.8807 14.1193 12 15.5 12C16.8807 12 18 10.8807 18 9.5V8.5H16V9.5C16 9.77614 15.7761 10 15.5 10C15.2239 10 15 9.77614 15 9.5ZM12 13C10.1481 13 8.53256 14.0074 7.66955 15.4993L7.16882 16.3649L8.90004 17.3663L9.40076 16.5007C9.92099 15.6014 10.8909 15 12 15C13.1092 15 14.0791 15.6014 14.5993 16.5007L15.1 17.3663L16.8312 16.3649L16.3305 15.4993C15.4675 14.0074 13.852 13 12 13Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-dissatisfaction-filled')
export default class DissatisfactionFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dissatisfaction-filled',
    }
  }
}
